export function ScoreDial({ value, label, tone = "primary", testId }) {
  const toneColor =
    tone === "risk"
      ? value <= 30 ? "#00FF66" : value <= 55 ? "#FFD700" : "#FF2A2A"
      : "#00F0FF";
  const r = 30;
  const c = 2 * Math.PI * r;
  const offset = c - (value / 100) * c;
  return (
    <div className="flex flex-col items-center gap-2" data-testid={testId}>
      <div className="relative w-[76px] h-[76px]">
        <svg width="76" height="76" className="-rotate-90">
          <circle cx="38" cy="38" r={r} stroke="#1A1D2D" strokeWidth="6" fill="none" />
          <circle
            cx="38" cy="38" r={r} stroke={toneColor} strokeWidth="6" fill="none"
            strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="butt"
            style={{ filter: `drop-shadow(0 0 6px ${toneColor}88)`, transition: "stroke-dashoffset 0.9s ease" }}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="font-mono font-bold text-lg" style={{ color: toneColor }}>{value}</span>
        </div>
      </div>
      <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{label}</span>
    </div>
  );
}
